var isEmptyArray = function isEmptyArray() {
  var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  if (!Array.isArray(arr)) {
    return true;
  }
  return arr === null || arr === void 0 ? void 0 : arr.every(function (element) {
    return !element || element === '';
  });
};
var getHeaderTitles = function getHeaderTitles(items) {
  if (typeof items[0][1] === 'string') {
    return [items[0][1]];
  }
  var filteredItems = items === null || items === void 0 ? void 0 : items.filter(function (item) {
    var _item$props;
    return !isEmptyArray(item === null || item === void 0 || (_item$props = item.props) === null || _item$props === void 0 ? void 0 : _item$props.children);
  });
  return filteredItems === null || filteredItems === void 0 ? void 0 : filteredItems.map(function (item) {
    var _item$props2;
    return item === null || item === void 0 || (_item$props2 = item.props) === null || _item$props2 === void 0 || (_item$props2 = _item$props2.children) === null || _item$props2 === void 0 ? void 0 : _item$props2.find(function (text) {
      return typeof text === 'string';
    });
  });
};
var getHeaderTitles$1 = getHeaderTitles;

export { getHeaderTitles$1 as default };
//# sourceMappingURL=getHeaderTitles.js.map
